import client from './util/client'

export default {
  search (params, token) {
    return client.request({
      uri: '/v1/places/',
      params,
      token
    })
  }
}
